<template>
    <PageStyleComponent :key="mainComponentKey" :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader">
        <template v-slot:body>
            <div class="border border-slate-200 rounded relative py-1.5 mt-3 px-2 min-h-[750px]">
                <h1 class="font-bold absolute top-[-13px] left-5 bg-white">Member Details</h1>
                <div class="tabs pt-2">
                    <button v-for="(tab, index) in tabs" :key="tab" :class="['tab', { active: activeTab === index }]"@click="selectTab(index)">
                        {{ tab }}
                    </button>
                </div>
                <div class="tab-content mt-3">
                    <div v-if="activeTab == 0">
                        <div class="flex">
                            <div class="basis-1/2 border-left border-gray-400">
                                <h1 class="font-bold mb-10">Member Biodata</h1>
                                <table class="w-full">
                                    <tr class="text-left">
                                        <td class="font-bold ">Member No:</td>
                                        <td> {{ memberDetails.member_number }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold">Member Name:</td>
                                        <td>{{ memberDetails.member_name }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Email:</td>
                                        <td>{{ memberDetails.email }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold">Phone No:</td>
                                        <td>{{ memberDetails.phone_number }}</td>
                                        
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">ID Number:</td>
                                        <td>{{ memberDetails.id_number }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Pin No:</td>
                                        <td>{{ memberDetails.kra_pin }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Town:</td>
                                        <td>{{ memberDetails.town }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Country:</td>
                                        <td>{{ memberDetails.country }}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td class="font-bold pt-3">Address:</td>
                                        <td>{{ memberDetails.address }}</td>
                                        <td></td>
                                        <td></td>
                                        <td class="font-bold pt-3">Joining Date:</td>
                                        <td>{{ memberDetails.joining_date }}</td>
                                    </tr>
                                    
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="activeTab == 1" class="text-left">                                 
                        <DynamicTable :key="tableKey" :rightsModule="rightsModule" :columns="loanColumns" :rows="computedLoanRows" :idField="idFieldLoan" :showTotals="hideTotals" :groupingKey=true :actions="actionsLoans" @action-click="loanActionClick" />
                    </div> 
                    <div v-show="activeTab == 2">                  
                        <DynamicTable :key="documentTableKey" :rightsModule="rightsModule" :columns="shareAccColumns" :rows="computedShareAccRows" :idField="idFieldDocument" :actions="actionsShareAcc" @action-click="documentActionClick"/>
                    </div> 
                    <div v-show="activeTab == 3">                  
                        <DynamicTable :key="tokenTableKey" :rightsModule="rightsModule" :columns="shareDepColumns" :rows="computedShareDepRows" :idField="idFieldToken" :actions="actionsUtility" @action-click="tokenActionClick" 
                                        :showActions="showActions" :showTotals="showTotals"/>
                    </div>  
                    <div v-show="activeTab == 4">                  
                        <DynamicTable :key="transferTableKey" :rightsModule="rightsModule" :columns="savingAccColumns" :rows="computedSavingAccRows" :idField="idFieldTransfer" :actions="actionsUtility" @action-click="transferActionClick" 
                                        :showActions="showActions" :showTotals="showTotals" />
                    </div>  
                    <div v-show="activeTab == 5">                  
                        <DynamicTable :key="tokenTableKey" :rightsModule="rightsModule" :columns="savingDepColumns" :rows="computedSavingDepRows" :idField="idFieldToken" :actions="actionsUtility" @action-click="tokenActionClick" 
                                        :showActions="showActions" :showTotals="showTotals"/>
                    </div> 
                </div>
            </div>
        </template>
    </PageStyleComponent>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onMounted, computed, watch, reactive } from 'vue';
import PageStyleComponent from '../PageStyleComponent.vue';
import FilterBar from "@/components/FilterBar.vue";
import DynamicTable from '@/components/DynamicTable.vue';
import DynamicForm from '../NewDynamicForm.vue';
import MovableModal from '@/components/MovableModal.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import axios from 'axios';
import PrintJS from 'print-js';
import Swal from 'sweetalert2';
import Member_Categories from '@/store/MMS/Member_Categories';

export default defineComponent({
    name: 'Member_Profile',
    components:{
        PageStyleComponent, DynamicTable, MovableModal, DynamicForm,FilterBar
    },
    setup(props,{emit}){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const { formatDate } = useDateFormatter();
        const current_date = new Date();
        const showAddButton = ref(false);
        const dep_modal_loader = ref('none');
        const util_modal_loader = ref('none');
        const tnt_modal_loader = ref('none');
        const rightsModule = ref('MMS');
        const allowedRights = ref([]);
        const depModalVisible = ref(false);
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Print Sale Statement');
        const displayButtons = ref(true);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const tabs = ref(['Member Details','Loans','Share Accounts','Share Deposits','Saving Accounts','Saving Deposits']);
        const activeTab = ref(0);
        const mainComponentKey = ref(0);
        const tableKey = ref(0);
        const tokenTableKey = ref(0);
        const scheduleTableKey = ref(0);
        const statementTableKey = ref(0);
        const documentTableKey = ref(0);
        const idFieldLoan = ref('loan_application_id');
        const idFieldToken = ref('utility_id');
        const idFieldStatement = ref('');
        const memberID = computed(()=> store.state.Members.selectedMemberID);
        const computedLoanRows = computed(()=> store.state.Members.memberLoans);
        const computedShareDepRows = computed(()=> store.state.Members.shareDeposits);
        const computedSavingDepRows = computed(()=> store.state.Members.savingDeposits);
        const computedSavingAccRows = computed(()=> store.state.Members.savingAccounts);
        const computedShareAccRows = computed(()=> store.state.Members.sharesAccounts);
        const memberDetails = computed(()=> store.state.Members.memberDetails);
        const loanColumns = ref([
            {type: "checkbox"},
            {label: "Date", key:"application_date"},
            {label: "Loan No", key:"loan_number", type:"link"},
            {label: "Applied", key: "formatted_applied_amount"},
            {label: "Approved", key: "formatted_approved_amount"},
            {label: "Disbursed", key: "disbursed"},
            {label: "Appr. Status", key:"approval_status", textColor: "textColor"},
            {label: "Loan Remarks", key:"loan_remarks"},
            {label: "Appr. By", key:"approved_by"},
            {label: "Exempt", key:"exempt_penalty"},
            {label: "Due", key:"loan_due_date"},
            {label: "Status", key:"loan_status", txtColor: "textStatusColor"},
        ]);
        const showTotals = ref(true);
        const hideTotals = ref(false);
        const actionsLoans = ref([
            {name: 'view', icon: 'fa fa-file-pdf-o', title: 'View Loan', rightName: 'Viewing Loan Ledger'},
        ]);

        const shareDepColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Acc No", key: "account_number"},
            {label: "Member No", key: "member_number"},
            {label: "Member Name", key: "member_name"},
            {label: "Share Product", key: "share_product"},
            {label: "Amount", key: "amount", type: "number"},
            {label: "Ref. No.", key: "reference_no"},
            {label: "Open. Bal.", key: "opening_balance"},
            {label: "Posting Account", key: "posting_account"},
            {label: "Txn. No.", key: "txn_no"},
        ]);
        const shareAccColumns = ref([
            {type: "checkbox"},
            {label: "Acc No", key: "account_number"},
            {label: "Member No", key: "member_number"},
            {label: "Member Name", key: "member_name"},
            {label: "Share Product", key: "share_product"},
            {label: "Min Shares", key: "amount"},
            {label: "Price", key: "share_price"},
            {label: "Quantity", key: "share_quantity"},          
            {label: "Share Amount", key: "total_amount", type: "number"},
            {label: "Variance", key: "variance"},
        ]);
        const actionsShareAcc = ref([
            {name: 'view', icon: 'fa fa-file-pdf-o', title: 'View Account', rightName: 'Viewing Share Account Statement'},
        ]);

        const showActions = ref(false);

        const savingAccColumns = ref([
            {type: "checkbox"},
            {label: "Acc No", key: "account_number"},
            {label: "Member No", key: "member_number"},
            {label: "Member Name", key: "member_name"},
            {label: "Saving Product", key: "saving_product"},
            {label: "Min Amnt", key: "amount"},
            {label: "Saving Amount", key: "total_amount", type: "number"},
        ]);
        const savingDepColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Acc No", key: "account_number"},
            {label: "Member No", key: "member_number"},
            {label: "Member Name", key: "member_name"},
            {label: "Saving Product", key: "saving_product"},
            {label: "Amount", key: "amount", type: "number"},
            {label: "Ref. No.", key: "reference_no"},
            {label: "Open. Bal.", key: "opening_balance"},
            {label: "Posting Account", key: "posting_account"},
            {label: "Txn. No.", key: "txn_no"},
        ]);

        const selectTab = async(index) => {
            showLoader();
            let formData = {
                company: companyID.value,
                member: memberID.value
            }
            let formData1 = {
                company: companyID.value,
                member: memberDetails.value.member_id,
                page_size: "1000"
            }
            if( index == 1){
                activeTab.value = index;
                await store.dispatch('Members/fetchMemberDetails',formData)
                .then(()=>{
                    hideLoader();
                })
            }
            else if( index == 3){
                activeTab.value = index;
                hideLoader();
            }else{
                activeTab.value = index;
                hideLoader();
            }

        };

        const showLoader = () =>{
            loader.value = "block";
        };
        const hideLoader = () =>{
            loader.value = "none";
        };

        const loanActionClick = async(rowIndex, action, row) =>{
            if(action == 'view'){
                const applicationID = row['loan_application_id'];
                const applicationStatus = row['approval_status']
                if(applicationStatus == 'Approved'){
                    let formData = {
                        company: companyID.value,
                        loan_application: applicationID
                    }
                    await store.dispatch('Loan_Applications/fetchLoanDetails',formData).
                    then(()=>{
                        store.commit('pageTab/ADD_PAGE', {'MMS':'Loan_Statement'})
                        store.state.pageTab.mmssActiveTab = 'Loan_Statement';
                    })
                }else{
                    toast.error(`Cannot View ${applicationStatus} Loan`)
                }
            }
        }
        const previewDocument = (formData) =>{
            showLoader();
            axios
            .post("api/v1/preview-asset-sale-document-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const documentActionClick = async(rowIndex, action, row) =>{
            if( action == 'preview'){
                const docID = row['sale_document_id'];
                let formData = {
                    sale_document: docID,
                    company: companyID.value
                } 
                previewDocument(formData);
                
            }
        }

        const tokenActionClick = async(rowIndex, action, row) =>{
            
        }
        const formFields = ref([
 
        ]);

        const handleDepReset = () =>{

        }
        const showDepModalLoader = () =>{
            dep_modal_loader.value = "block";
        }
        const hideDepModalLoader = () =>{
            dep_modal_loader.value = "none";
        }
        const additionalFields = ref([

        ]);
        

        const isDisabled =(permissionName) =>{
            const permission = allowedRights.value.find(p => p.permission_name === permissionName);
            return permission ? !permission.right_status : true;
        };
        onBeforeMount(()=>{
            memberDetails.value = store.state.Members.memberDetails;
        });
        onMounted(()=>{

        });

        return{
            tabs, activeTab, mainComponentKey, shareDepColumns, selectTab, loader, showLoader, hideLoader, formFields, additionalFields,showTotals,
            tableKey,tokenTableKey, idFieldLoan, idFieldToken, computedLoanRows, computedShareDepRows,computedSavingAccRows,hideTotals,computedSavingDepRows,
            scheduleTableKey, loanColumns, actionsLoans,showActions,memberDetails,showAddButton, savingAccColumns,savingDepColumns,     
            loanActionClick,tnt_modal_loader, dep_modal_loader, util_modal_loader, depModalVisible, displayButtons,
            documentActionClick,shareAccColumns,documentTableKey,actionsShareAcc,computedShareAccRows,printModalVisible,pdfUrl, printTitle,
            modal_top, modal_left, modal_width, showDepModalLoader, hideDepModalLoader, handleDepReset,
            flex_basis, flex_basis_percentage, tokenActionClick,rightsModule,isDisabled,
        }
    }
})
</script>

<style scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.tabs {
    display: flex;
    border-bottom: 1px solid #ccc;
}
.tab {
    padding: 2px 20px 2px 20px;
    cursor: pointer;
}

.tab.active {
    border-bottom: 2px solid #000;
}

.tab-content {
    padding: 1px;
}

.table{
    min-height: 15vh;
    max-height: 15vh;
    overflow-y: scroll;
    overflow-x: scroll;
}

</style>